import ChevronComponent from "@/tpo/Chevron";
import LinkWrapper from "@/tpo/LinkWrapper";
import { ActionIcon } from "@/v2/Buttons";

export default function DashboardCircleArrow({
  to,
  bg = "white",
  chevronFill = "#17224D",
  linked = true
}) {
  return (
    <ActionIcon
      bg={bg}
      width={40}
      height={40}
      minWidth={40}
      minHeight={40}
      variant="circle"
      as={linked ? LinkWrapper : undefined}
      to={linked ? to : undefined}
      flexShrink={0}
    >
      <ChevronComponent
        fill={chevronFill}
        style={{
          margin: 0
        }}
      />
    </ActionIcon>
  );
}
